import React from 'react';
import { Fieldset, FormRadio, Selectize } from '~/components/FormControl';
import { formLabel } from '~/utils/helpers';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

function OthersCheck({ biomes }) {
    return (
        <>
            {biomes.length > 0 && (
                <Fieldset className={'px-2'}>
                    <Fieldset.Legend>{formLabel('OthersCheck')}</Fieldset.Legend>
                    <Form.Row>
                        <Selectize
                            name="biomeIds"
                            sm={6}
                            options={biomes}
                        />
                        <FormRadio
                            name="hasActionCard"
                            sm={6}
                        />
                    </Form.Row>
                    <Form.Row className="mt-3">
                        <FormRadio
                            name="isDuelBlind"
                            sm={6}
                        />
                    </Form.Row>
                </Fieldset>
            )}
        </>
    );
}

OthersCheck.defaultProps = {
    biomes: [],
};
OthersCheck.propTypes = {
    biomes: PropTypes.array,
};

export default OthersCheck;
